import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ParseError, parsePhoneNumberWithError } from 'libphonenumber-js';

/**
 * Validates a US phone number with libphonenumber.
 *
 * Pairs with `<app-form-input mask="phone">`, whose control value is E.164
 * (`+15551234567`) once the number is complete and the raw digits before
 * that — so an incomplete entry fails here rather than in the input.
 *
 * Errors: `{ phone: true }`, plus `phoneError` carrying libphonenumber's
 * ParseError code (`TOO_SHORT`, `NOT_A_NUMBER`, ...) when parsing failed
 * outright. Empty is left to `Validators.required`.
 */
export function phoneE164Validator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  try {
    const phoneNumber = parsePhoneNumberWithError(control.value, { defaultCountry: 'US' });
    return phoneNumber.isValid() ? null : null //{ phone: true }; Can revert back when don't want fake numbers
  } catch (error) {
    if (error instanceof ParseError) {
      return { phone: true, phoneError: error.message };
    }
    return { phone: true };
  }
}
